module.exports = __webpack_public_path__ + "img/cooperate_2.2ccfdea1.png";